var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", { staticClass: "cmp cmp-product-thumb" }, [
    _c(
      "div",
      { class: _vm.paddingClasses, style: _vm.paddingInlineStyles },
      [
        _c("div", { staticClass: "thumb-image" }, [
          _c(
            "div",
            { staticClass: "prop-1-1" },
            [
              _vm._t("item-image", [
                _c("category-image-carousel", {
                  ref: "categoryImageCarousel",
                  attrs: {
                    "image-urls-data": _vm._f("itemImages")(
                      _vm.item.images,
                      _vm.imageUrlAccessor
                    ),
                    alt: _vm._f("itemName")(_vm.item),
                    title: _vm._f("itemName")(_vm.item),
                    "item-url": _vm._f("itemURL")(
                      _vm.item,
                      _vm.urlWithVariationId
                    ),
                    "enable-carousel":
                      _vm.$ceres.config.item.enableImageCarousel,
                    "disable-carousel-on-mobile": _vm.disableCarouselOnMobile
                  }
                })
              ])
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("tag-list", {
          attrs: {
            tags: _vm.item.tags,
            "recommended-retail-price": _vm.item.prices.rrp,
            "variation-retail-price": _vm.item.prices.default,
            "decimal-count": "0"
          }
        }),
        _vm._v(" "),
        _vm._t("item-details", [
          _c("div", { staticClass: "thumb-content" }, [
            _c(
              "div",
              { staticClass: "category-wishlist-wrapper" },
              [
                _c(
                  "div",
                  { staticClass: "category-item-ratings" },
                  [_vm._t("before-prices")],
                  2
                ),
                _vm._v(" "),
                _c("add-to-wish-list", {
                  attrs: { "variation-id": _vm.item.variation.id }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                class: {
                  "stretched-link":
                    _vm.$ceres.config.global.shippingCostsCategoryId == 0
                },
                attrs: {
                  href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId)
                }
              },
              [
                _c("span", { staticClass: "thumb-title small" }, [
                  _vm._v(_vm._s(_vm._f("itemName")(_vm.item)))
                ]),
                _vm._l(_vm.item.groupedAttributes, function(attribute) {
                  return _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm._f("translate")(
                          "Ceres::Template.itemGroupedAttribute",
                          attribute
                        )
                      )
                    )
                  ])
                }),
                _vm._v(" "),
                _c("div", { staticClass: "thumb-meta mt-2" }, [
                  _c("div", { staticClass: "prices" }, [
                    _vm.item.prices.rrp &&
                    _vm.item.prices.rrp.price.value > 0 &&
                    _vm.item.prices.rrp.price.value >
                      _vm.item.prices.default.price.value
                      ? _c("div", { staticClass: "price-view-port" }, [
                          _vm.item.prices.specialOffer
                            ? _c("del", { staticClass: "crossprice" }, [
                                _vm._v(
                                  "\n                          " +
                                    _vm._s(
                                      _vm.item.prices.default.unitPrice
                                        .formatted
                                    ) +
                                    "\n                        "
                                )
                              ])
                            : _c("del", { staticClass: "crossprice" }, [
                                _vm._v(
                                  "\n                          " +
                                    _vm._s(
                                      _vm.item.prices.rrp.unitPrice.formatted
                                    ) +
                                    "\n                        "
                                )
                              ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "price",
                        class: {
                          hasCrossPrice:
                            _vm.item.prices.rrp &&
                            _vm.item.prices.rrp.price.value > 0 &&
                            _vm.item.prices.rrp.price.value >
                              _vm.item.prices.default.price.value
                        }
                      },
                      [
                        _vm.item.item.itemType === "set"
                          ? [
                              _vm._v(
                                "\n                          " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.itemSetPrice",
                                      { price: _vm.itemSetPrice }
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                          : _vm.itemGraduatedPriceisCheapestSorting
                          ? [
                              _vm._v(
                                "\n                          " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.categoryItemFromPrice",
                                      { price: _vm.itemPriceGraduated }
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                          : _vm.itemGraduatedPricesalableVariationCount
                          ? [
                              _vm._v(
                                "\n                          " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.categoryItemFromPrice",
                                      { price: _vm.itemPriceGraduated }
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                          : [
                              _vm._v(
                                "\n                          " +
                                  _vm._s(
                                    _vm._f("specialOffer")(
                                      _vm.item.prices.default.unitPrice
                                        .formatted,
                                      _vm.item.prices,
                                      "unitPrice",
                                      "formatted"
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._t("after-prices"),
                _vm._v(" "),
                _vm.item.prices.default.lowestPrice.value && _vm.hasCrossPrice
                  ? _c("div", { staticClass: "category-lowest-price small" }, [
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$translate("Ceres::Template.itemLowestPrice", {
                              price:
                                _vm.item.prices.default.lowestPrice.formatted
                            })
                          )
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !(
                  _vm.item.unit.unitOfMeasurement === "C62" &&
                  _vm.item.unit.content === 1
                )
                  ? _c("div", { staticClass: "category-unit-price small" }, [
                      _c("span", [_vm._v(_vm._s(_vm.item.unit.content))]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.item.unit.names.name))
                      ]),
                      _vm._v(" "),
                      _vm.item.variation.mayShowUnitPrice
                        ? _c("span", [_vm._v(" | " + _vm._s(_vm.basePrice))])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.item.variation.availability &&
                !_vm.item.filter.hasActiveChildren
                  ? _c(
                      "span",
                      {
                        class:
                          "availability availability_" +
                          _vm.item.variation.availability.id
                      },
                      [
                        _vm._v(
                          "\n                              " +
                            _vm._s(_vm.item.variation.availability.names.name) +
                            "\n                  "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                !!_vm.item.item &&
                _vm.item.item.salableVariationCount > 1 &&
                _vm.$ceres.isCheapestSorting
                  ? _c("div", { staticClass: "text-center more-variants" }, [
                      _c("b", [_vm._v("+ weitere Varianten verfügbar")])
                    ])
                  : _vm._e()
              ],
              2
            )
          ])
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }